const NODE_ENV = {
  TEST: 'test',//测试环境
  DEV: 'dev',   //开发环境
  PROD: 'prod', //生产环境
}
export default NODE_ENV
